// extracted by mini-css-extract-plugin
export var typingIndicator = "_m2-0";